import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";

export class RemoveImplant extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis = tooth.diagnosis.filter(
          (_item) => _item.condition !== "implant",
        );
        tooth.implant = false;
      });

    return odontogram;
  }

  static getIdentifier(): string {
    return "remove-implant";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/implants/remove-implant.ts